import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconCustomize2 = t0 => {
  const $ = _c(11);
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
  } else {
    otherProps = $[1];
    t1 = $[2];
  }
  const color = t1 === undefined ? "#585858" : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M29.573 24.436H15.61a2.918 2.918 0 01-2.918-2.918v-17.5a2.918 2.918 0 012.918-2.917h13.964a2.917 2.917 0 012.918 2.917v17.5a2.917 2.917 0 01-2.918 2.918z" />;
    t3 = <path d="M12.691 4.267l-9.678 3.56a2.918 2.918 0 00-1.734 3.746l6.04 16.423a2.92 2.92 0 003.747 1.733l11.322-4.163 7.615 4.397a2.919 2.919 0 003.987-1.067l8.748-15.154a2.915 2.915 0 00-1.067-3.987l-9.18-5.301" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== color) {
    t4 = <g stroke={color} strokeWidth={2} fill="none" fillRule="evenodd">{t2}{t3}</g>;
    $[5] = color;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== color || $[8] !== otherProps || $[9] !== t4) {
    t5 = <svg width={45} height={32} viewBox="0 0 45 32" color={color} {...otherProps}>{t4}</svg>;
    $[7] = color;
    $[8] = otherProps;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
IconCustomize2.propTypes = {
  color: PropTypes.string
};
export default IconCustomize2;